import { atom } from "jotai";

type Profile = {
  memberId: string;
  membershipTypeId: string;
  firstName: string;
  lastName: string;
  profileImagePublicId?: string;
  memberGroups: { id: string }[];
  hasSeenNotificationNudgeModal: boolean;
  email?: string;
  phoneNumber?: string;
  ghinNumber?: number | null;
};

// We need to keep an atom of the current profile so that we can reach
// down into places like the booking details where we need to know the current
// logged in user to add the to the booking, check ownership etc.
export const currentProfileAtom = atom<Profile | null>(null);
